import { z } from 'zod'

export function validatePhoneString(val: string | null | undefined, required: boolean = true): string | null {
  const trimmed = (val || '').trim()
  if (!trimmed) {
    return required ? 'Phone number is required.' : null
  }
  if (/[^\d]/.test(trimmed)) {
    return 'Phone number must contain only digits.'
  }
  if (trimmed.length !== 10) {
    return 'Phone number must be exactly 10 digits.'
  }
  if (!/^[6-9]/.test(trimmed)) {
    return 'Phone number must start with 6, 7, 8, or 9.'
  }
  return null
}

export function createPhoneSchema(required: boolean = true) {
  return z.string().superRefine((val, ctx) => {
    const error = validatePhoneString(val, required)
    if (error) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: error,
      })
    }
  })
}

export const phoneSchema = createPhoneSchema(true)
export const optionalPhoneSchema = createPhoneSchema(false)
